// Short git SHA this bundle was built from.
//
// `COMMIT_HASH` is a compile-time global injected by Umi `define` (see `.umirc.ts`),
// sourced from build.sh (`COMMIT_HASH=$(parse_git_hash)`). Reading it once here gives a
// single source of truth imported where needed (window.__COMMIT_HASH__ in app.tsx and the
// Sentry `release`). Falls back to 'development' for local builds where no SHA is injected;
// the `typeof` guard keeps it from throwing if the global is ever absent.
export const BUILD_COMMIT_HASH: string =
  typeof COMMIT_HASH !== 'undefined' ? COMMIT_HASH : 'development';
